import { render, staticRenderFns } from "./LcfsPagination.vue?vue&type=template&id=d88066d0&scoped=true"
import script from "./LcfsPagination.vue?vue&type=script&lang=js"
export * from "./LcfsPagination.vue?vue&type=script&lang=js"
import style0 from "./LcfsPagination.vue?vue&type=style&index=0&id=d88066d0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d88066d0",
  null
  
)

export default component.exports